import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import { RendererProps } from "../BaseRenderer";
import { ChoiceModel } from "../../../models/ChoiceModel";
import useStyle from "./NetPromoterItemRenderer.styles";
import useTranslatable from "../../../hooks/useTranslatable";
import useDimensionContext from "../../../hooks/useDimensionContext";

interface Props extends RendererProps {
    choice?: ChoiceModel;
    selected?: boolean;
    onSelect?(choice: ChoiceModel): void;
}

export default function NetPromoterItemRenderer(props: Props) {
    const { choice, selected, onSelect } = props;
    const theme = useTheme();
    const dimension = useDimensionContext();
    const classes = useStyle({ theme, selected, dimension });
    const label = useTranslatable(choice, "Text");
    const [active, setActive] = React.useState(false);
    const acceptedKeyCodes = [13, 32]; //Enter, Space

    return (
        <div
            role="radio"
            aria-checked={selected}
            tabIndex={0}
            className={classnames(
                classes.choice,
                dimension && dimension.maxWidth(480) && classes.dynamicChoice,
                selected && classes.choiceSelected,
                active && classes.choiceActive,
            )}
            style={{}}
            onFocus={() => setActive(true)}
            onBlur={() => setActive(false)}
            onMouseOver={() => setActive(true)}
            onMouseOut={() => setActive(false)}
            onClick={() => onSelect(choice)}
            onKeyDown={(event) => {
                if (acceptedKeyCodes.includes(event.keyCode)) {
                    onSelect(choice);
                    event.preventDefault();
                }
            }}
        >
            <div className={classnames(classes.content, active && classes.choiceActive)}>
                <span>{label}</span>
            </div>
        </div>
    );
}
